import React from 'react';

interface AgentTypingIndicatorProps {
  elapsed: number;
}

const AgentTypingIndicator: React.FC<AgentTypingIndicatorProps> = ({ elapsed }) => {
  const seconds = Math.floor(elapsed / 1000);

  let text: string;
  if (seconds < 3) {
    text = 'AI думает...';
  } else if (seconds < 8) {
    text = 'AI анализирует...';
  } else {
    text = 'AI выполняет действия...';
  }

  return (
    <div
      className="flex items-center gap-2 px-4-py-3"
      role="status"
      aria-live="polite"
      aria-label="AI обрабатывает запрос"
    >
      <div className="flex gap-1">
        {[0, 1, 2].map(i => (
          <span
            key={i}
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: 'var(--gray-400)',
              animation: 'supportChatDotPulse 1.4s infinite',
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>
      <span className="text-xs-gray-500">
        {text}
      </span>
    </div>
  );
};

export default AgentTypingIndicator;
